import {SessionStorageKey, getFromSessionStorage, setInSessionStorage} from "../sessionStorage";

export const setSessionStart = (ms: number) => setInSessionStorage(SessionStorageKey.StartTime, ms);

export const getSessionStart = () => getFromSessionStorage(SessionStorageKey.StartTime);
